// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"97586299","597":"55487e3d","963":"81da6290"}[chunkId] + ".css";
};